import axios from "axios";
import { handleAPIError, handleAPISuccess, removeEmptyFields } from "./utils/utilsAPI";
import { hostRegistrationValidation, loginValidate, validateEmail } from "./utils/validateAPI";
import { getConfig, TEST_URL } from "./constant";
import Cookies from "js-cookie";
import store from "../store";
import { successToast } from "../store/dbFilter/actions";

// const token = "8lQzN922rpRDaMbh3m5J";

const apiHostLogin = axios.create({
  baseURL: `${TEST_URL}/hosts`,
});

/**
 * validates the argument received and Makes an API call to create or update the charger
 * @param {object} hostDetail - contains all the data required to create a charger
 * @returns {Promise} - Resolves when the promise returns chargerId details  or logs in case of failure.
 */
const hostLogin = async (email, password, isRemember) => {
  const obj = removeEmptyFields({ email: email, password: password });
  //   const payload = { token: token, ...obj };
  try {
    await loginValidate.validate(obj);
    const res = await apiHostLogin.post(`/login`, obj);
    const apiSuccess = handleAPISuccess(res);
    console.log("Api Success: ", apiSuccess);
    //  validateToken(apiSuccess?.data?.token);
    return apiSuccess?.data?.token;
  } catch (err) {
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to create or update the charger
 * @param {object} hostDetail - contains all the data required to create a charger
 * @returns {Promise} - Resolves when the promise returns chargerId details  or logs in case of failure.
 */
const validateToken = async (token, isRemember = false) => {
  // const obj = removeEmptyFields(token);
  //   const payload = { token: token, ...obj };
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    // await tokenValidation.validate(obj);
    const res = await apiHostLogin.get(`/validate`, config);
    const tokenValidated = handleAPISuccess(res);
    if (isRemember) {
      // store token in cookies

      Cookies.set("token", token, { expires: 90 });
    }
    sessionStorage.setItem("token", token);
    // store token in session
    return tokenValidated?.data;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const getInitialData = async (email, token) => {
  // console.log("config: ", config);
  console.log("sessionStorage.getItem", sessionStorage.getItem("token"));

  try {
    await validateEmail.validate(email);
    const res = await apiHostLogin.get(`/getChargersandLocations`, {
      params: { email: email },
      headers: { Authorization: `Bearer ${token}` },
    });
    const initialData = handleAPISuccess(res);
    console.log("initialData: ", initialData);

    return initialData?.data;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to create or update the charger
 * @param {object} hostDetail - contains all the data required to create a charger
 * @returns {Promise} - Resolves when the promise returns chargerId details  or logs in case of failure.
 */
const hostRegister = async (hostDetail) => {
  const obj = removeEmptyFields(hostDetail);
  //   const payload = { token: token, ...obj };
  try {
    await hostRegistrationValidation.validate(obj);
    const res = await apiHostLogin.post(`/register`, obj);
    const { message, data } = handleAPISuccess(res);
    console.log(`${message}`, data);
    store.dispatch(successToast({ title: "Success", message: message }));
  } catch (err) {
    handleAPIError(err); // Call error handler
    throw err;
  }
};

// get Host details by email/hostId
const getHostById = async (id) => {
  const payload = {
    email: id,
  };
  try {
    // await chargerIdValidation.validate(payload);
    const res = await apiHostLogin.get(`/getHostbyId`, { params: payload, ...getConfig() });
    const { data } = handleAPISuccess(res);
    if (data?.length === 0) {
      console.log("Host not found");
      // store.dispatch(errToast({ title: "Err", message: "Charger not found" }));
    }
    return data;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const sendOTP = async (email) => {
  const payload = { email: email };
  try {
    const res = await apiHostLogin.post(`/sendResetOtp`, payload);
    const { message, data } = handleAPISuccess(res);
    console.log(`${message}`, data);
    if (message === "OTP sent to email") {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const resetPass = async (hostDetail) => {
  const obj = removeEmptyFields(hostDetail);
  const payload = { ...obj };
  try {
    // await resetPassValidation.validate(obj);
    const res = await apiHostLogin.post(`/resetPassword`, payload);
    const { message, data } = handleAPISuccess(res);
    console.log(`${message}`, data);
    if (message === "Password reset successful") {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    handleAPIError(err); // Call error handler
    throw err;
  }
};

const getChargerIdsForHost = async (email) => {
  try {
    await validateEmail.validate(email);
    const res = await apiHostLogin.get(`/getChargersandLocations`, {
      params: { email: email },
      ...getConfig(),
    });
    const initialData = handleAPISuccess(res);
   
    return initialData?.data;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

export { hostLogin, validateToken, getInitialData, hostRegister, getHostById, sendOTP, resetPass,getChargerIdsForHost };
